import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Chat outlined SVG Icon for chat toggle button.
 */
export const ChatOutlined: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M23.3334 2.33337H4.66671C3.38337 2.33337 2.33337 3.38337 2.33337 4.66671V25.6667L7.00004 21H23.3334C24.6167 21 25.6667 19.95 25.6667 18.6667V4.66671C25.6667 3.38337 24.6167 2.33337 23.3334 2.33337ZM23.3334 18.6667H7.00004L4.66671 21V4.66671H23.3334V18.6667Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
